import gql from 'graphql-tag';

export default gql`
  mutation updateLessonHomeTaskMutation($lessonId: MongoID!, $homeTaskId: MongoID!, $status: String!) {
    updateLessonHomeTaskMutation(lessonId: $lessonId, homeTaskId: $homeTaskId, status: $status) {
      _id
      id
      data {
        homeTaskStatus
      }
    }
  }
`;
